export const isValidChecksum = (employeeId: string[]) => {
  // verify we got 10 digits, otherwise it is invalid
  if (employeeId.length !== 10) {
    return false;
  }

  const sum = employeeId
    // convert to number
    .map((n: string) => Number(n))
    // perform arithmetic and return sum
    .reduce((previous: number, current: number, index: number) => {
      // multiply every other number with two
      if (index % 2) {
        current *= 2;
      }
      // if larger than 10 get sum of individual digits (also n-9)
      if (current > 9) {
        current -= 9;
      }
      // sum it up
      return previous + current;
    });
  // sum must be divisible by 10
  return sum % 10 === 0;
};
